import React from 'react'
import { useSelector } from 'react-redux'
import Linkify, { linkify } from 'react-linkify'

import { formatValue } from '../../../utils/formatting'
import { getCurrentOrganizationId } from '../../../ducks/users'
import { getViewLink } from '../../../ducks/views'
import Accordion from '../Accordion'
import Chip from '../Chip'

import styles from './ObjectExplorer.module.css'

// Customize Linkinfy
linkify.add('data:', { validate: /^[^\s]+/ })

const summarizeObject = object => {
  return 'Object'
}

const Title = function ObjectExplorerTitle({ children }) {
  return (
    <div className={styles.titleWrapper}>
      <div className={styles.title}>{children}</div>
    </div>
  )
}

const Reference = function ObjectReference({ object }) {
  const { databaseId, table, __pk: id, label } = object
  const orgId = useSelector(getCurrentOrganizationId)

  const link = useSelector(getViewLink(orgId, databaseId, table, id))

  return (
    <Chip link={link} icon="link" disabled={!link}>
      {label}
    </Chip>
  )
}

const Link = function Link({ href, children }) {
  if (
    href.match(/^data:image/) ||
    href.match(/^https:\/\/\.(jpg|png|gif|webp|jpeg)$/)
  ) {
    return (
      <span>
        <img src={href} width={200} alt="photo url" />
      </span>
    )
  } else if (href.match(/^data:/)) {
    return <span>{children}</span>
  }

  if (children && typeof children === 'string' && children.length > 100) {
    children = `${children.slice(0, 50)}...${children.slice(-50)}`
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.link}
    >
      {children}
    </a>
  )
}

export default function ObjectExplorer({ object, column }) {
  if (Array.isArray(object)) {
    return (
      <div className={styles.array}>
        {object.map(obj => (
          <ObjectExplorer object={obj} />
        ))}
      </div>
    )
  }

  if (object && object.__pk) {
    return <Reference object={object} />
  }

  if (object && typeof object === 'object' && !object._seconds) {
    return (
      <Accordion
        carret
        tight
        title={<Title>{summarizeObject(object)}</Title>}
        expandedClassName={styles.expanded}
        className={styles.accordion}
      >
        {() => (
          <div className={styles.children}>
            {Object.keys(object).map(key => (
              <div className={styles.item}>
                <label>{key}</label>
                <ObjectExplorer object={object[key]} />
              </div>
            ))}
          </div>
        )}
      </Accordion>
    )
  }

  const formattedValue = formatValue(object, column)

  return (
    <div className={styles.value}>
      <Linkify component={Link}>{formattedValue}</Linkify>
    </div>
  )
}
